import React, { useState, useMemo, useImperativeHandle, forwardRef } from "react";
import axios from "axios";
import { debounce } from "lodash";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { ProductsApiService } from "api/admin.api";

const ProductComboBox = forwardRef(({ onSelect, filters = {} }, ref) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);

  const fetchProducts = async (query, filters) => {
    try {
      setLoading(true);
      const response = await ProductsApiService.getProducts({
        keyword: query,
        pageNumber: 1,
        pageSize: 100,
        status: 1,
        ...filters,
      });
      setProducts(response?.data?.data?.data ?? []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetch = useMemo(() => debounce(fetchProducts, 500), [filters]);

  const handleInputChange = (event, value) => {
    setSearchTerm(value);
    debouncedFetch(value, filters);
  };

  useImperativeHandle(ref, () => ({
    reset() {
      setSelectedProduct(null);
      onSelect(null);
    },
  }));

  return (
    <Autocomplete
      options={products}
      getOptionLabel={(option) => `${option.sku ?? ""} ${option.title}`}
      loading={loading}
      onInputChange={handleInputChange}
      onChange={(event, newValue) => {
        setSelectedProduct(newValue);
        onSelect(newValue);
      }}
      value={selectedProduct}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder="Type to search products"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <span>Loading...</span> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
});

export default ProductComboBox;
